import apiConfig from 'constants/apiConfig';
import {
    DiscoverCreatorsResponse,
    DiscoveredCreatorsResponse,
    DiscoveryCreatorSort,
    DiscoveryDetails,
    RecentDiscoveriesResponse,
} from 'types/creator-discovery';
import axiosClient from 'utils/axiosClient';

const withDiscoveryId = (url: string, discoveryId: string) => url.replace('<discoveryId>', discoveryId);

export const discoverCreators = async (query: string): Promise<DiscoverCreatorsResponse> => {
    const response = await axiosClient.post(apiConfig.DISCOVER_CREATORS.url, { query });
    return response.data;
};

export const fetchCreatorDiscoveryDetails = async (discoveryId: string): Promise<DiscoveryDetails> => {
    const response = await axiosClient.get(withDiscoveryId(apiConfig.FETCH_CREATOR_DISCOVERY_DETAILS.url, discoveryId));
    return response.data;
};

export const fetchDiscoveredCreators = async (
    discoveryId: string,
    page = 1,
    sort: DiscoveryCreatorSort = 'rank',
    limit?: number
): Promise<DiscoveredCreatorsResponse> => {
    const response = await axiosClient.get(withDiscoveryId(apiConfig.FETCH_DISCOVERED_CREATORS.url, discoveryId), {
        params: {
            page,
            sort,
            ...(limit !== undefined ? { limit } : {}),
        },
    });
    return response.data;
};

export const fetchRecentDiscoveries = async (
    page = 1,
    q?: string
): Promise<RecentDiscoveriesResponse> => {
    const response = await axiosClient.get(apiConfig.RECENT_DISCOVERIES.url, {
        params: {
            page,
            ...(q ? { q } : {}),
        },
    });
    return response.data;
};
